import AttestationIndex from '@/pages/student/attestation/Index'
import AttestationIntro from '@/pages/student/attestation/Intro'
import AttestationTest from '@/pages/student/attestation/Test'
import AttestationThematic from '@/pages/student/attestation/Thematic'
import AttestationPractice from '@/pages/student/attestation/Practice'
import AttestationResult from '@/pages/student/attestation/Result'
import AttestationService from '@/services/AttestationService'
import store from '@/store'

const attestationService = new AttestationService(store)

export default [
  {
    path: '/attestation',
    name: 'AttestationIndex',
    component: AttestationIndex,
    meta: {roles: ['ROLE_STUDENT']},
    beforeEnter (to, from, next) {
      isTraining(to, from, next)
    }
  },
  {
    path: '/attestation/intro',
    name: 'AttestationIntro',
    component: AttestationIntro,
    meta: {roles: ['ROLE_STUDENT']},
    beforeEnter (to, from, next) {
      isTraining(to, from, next)
    }
  },
  {
    path: '/attestation/test',
    name: 'AttestationTest',
    component: AttestationTest,
    meta: {roles: ['ROLE_STUDENT']}
  },
  {
    path: '/attestation/thematic',
    name: 'AttestationThematic',
    component: AttestationThematic,
    meta: {roles: ['ROLE_STUDENT']}
  },
  {
    path: '/attestation/practice',
    name: 'AttestationPractice',
    component: AttestationPractice,
    meta: {roles: ['ROLE_STUDENT']}
  },
  {
    path: '/attestation/result/:id',
    name: 'AttestationResult',
    props: true,
    component: AttestationResult,
    meta: {roles: ['ROLE_STUDENT']}
  },
  {
    path: '/attestation/result/training',
    name: 'AdminTrainingResults',
    component: AttestationResult,
    meta: {roles: ['ROLE_STUDENT']}
  }
]

function isTraining (to, from, next) {
  attestationService.isTraining((data) => {
    let isTraining = data.status
    sessionStorage.setItem('isTraining', isTraining)
    if (to.name === 'AttestationIndex' && !isTraining) {
      next({name: 'AttestationIntro'})
    } else {
      next()
    }
  })
}



// WEBPACK FOOTER //
// ./src/router/attestation.js